import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { Video } from '../../../models/video';
import { VideoListItem } from '../../../models/videoListItem';
import { VideoBundle } from '../../../models/videoBundle';

@Component({
  selector: 'app-video',
  host: {
    "[style.display]": "'inline-block'",
    "[style.width]": "'100%'",
    "[style.height]": "'100%'"
  },
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
  // encapsulation: ViewEncapsulation.Native
})
export class VideoComponent implements OnInit, AfterViewInit {

  @ViewChild("videoplayer") videoPlayer: ElementRef;

  @Input() videoBundle: VideoBundle;

  videoWidth: number;
  videoHeight: number;

  maxWidth: number;

  url: string;
  overlayString: string

  constructor() { }

  ngOnInit() {
    // console.log("VIDEO video=", this.videoBundle);
    this.url = this.videoBundle.video.videoUrl;
    this.overlayString = this.videoBundle.videoListItem.cameraName;
  }

  ngAfterViewInit() {
    
  }

  getVideoSize(videometadata: any) {
    setTimeout(() => {
      //console.log(`videoplayer: width=${this.videoWidth}, height=${this.videoHeight}, offsetHeight=${this.videoPlayer.nativeElement.offsetHeight}, offsetWidth=${this.videoPlayer.nativeElement.offsetWidth}`);

      this.videoWidth = videometadata.srcElement.videoWidth;
      this.videoHeight = videometadata.srcElement.videoHeight;
      
      let videoOffsetHeight = this.videoPlayer.nativeElement.offsetHeight; // height that the DOM decides the video can fit into

      // Get ratio of width/height, then find the width that matches ratio to offsetHeight
      this.maxWidth = this.videoWidth / this.videoHeight * videoOffsetHeight;
    });
  }
}
